import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import * as XLSX from 'xlsx';
import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { finalize, map } from 'rxjs/operators';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-upload-students',
  templateUrl: './upload-students.component.html',
  styleUrls: ['./upload-students.component.sass']
})
export class UploadStudentsComponent implements OnInit {
  type_accept: string = '.xlsx';
  selectedFiles: File = null;
  studentForm: FormGroup;
  stages: any;
  stagesListSubs: Subscription;
  private routeSub: Subscription;
  gradesListSubs: Subscription;
  grades: any;
  title: string;
  message: string;
  ok_txt: string;
  showPrimarySpinner: boolean = false;
  files: any[] = [];
  files_list: any[] = [];


  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    public firebaseStorageService: FirebaseStorageService,
    private snackbar: MatSnackBar

  ) { }

  public getStages(schoolID: string) {
    this.stages = [{ 'id': null, 'name': "" }]
    this.grades = [{ 'id': null, 'name': "" }]
    this.studentForm.controls["stages"].setValue('')
    this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')

    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        this.stages = res;
        this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
        // this.studentForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])
      },
        console.error
      );
  }

  public getGrades(stageID: string) {
    this.studentForm.controls["grades"].setValue('')

    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID

    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;
        this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        // this.studentForm.controls["grades"].setValue(res[0]['id'])
        // this.getLines(res[0]['id'])
      },
        console.error
      );
  }

  ngOnInit() {
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.routeSub = this.route.params.subscribe(params => {
      if (params.id_school) {
        
        this.getStages(params.id_school)

      }
    })
  }

  uploadStudents() {
    this.showPrimarySpinner = true;
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();



    if (this.selectedFiles != null) {
      const file = this.selectedFiles[0]
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        let params = {}
        this.routeSub = this.route.params.subscribe(r => {
          params['school_id'] = r.id_school
        })
        params['stage_id'] = this.studentForm.controls["stages"].value;
        params['grade_id'] = this.studentForm.controls["grades"].value;

        params['excel_file'] = JSON.stringify(jsonData);

        this.translate.get('alerts.atention').subscribe(res => {
          this.title = res;
        })

        this.translate.get('alerts.checkUploadStudent').subscribe(res => {
          this.message = res;
        })

        this.translate.get('buttons.ok').subscribe(res => {
          this.ok_txt = res;
        })

        
        this.dataService.checkStudents(params).subscribe(res => {
          this.showPrimarySpinner = false;
          this.message = this.message.replace('{{modify}}', res.modify)
          this.message = this.message.replace('{{new_students}}', res.new_students)


          let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
            data: {
              message: this.message,
              title: this.title,
              ok_txt: this.ok_txt,
            }
          }).afterClosed().subscribe(res2 => {

            if (res2 === true) {
              let dateTime = new Date()
              this.showPrimarySpinner = true;
              const filePath = 'upload_excels/' + params['school_id'] + '/' + params['stage_id'] + '/' + params['grade_id'] + '/' + dateTime + ' - ' + localStorage.getItem('email') + ' - ' + this.selectedFiles[0].name;
              const storageRef = this.firebaseStorageService.referenciaCloudStorage(filePath);
              const uploadTask = this.firebaseStorageService.tareaCloudStorage(filePath, this.selectedFiles[0]);
              uploadTask.snapshotChanges().pipe(
                finalize(() => {
                  this.dataService.uploadStudents(params).subscribe(res3 => {
                    if (res3.status == 'ok') {
                      this.showPrimarySpinner = false;
                      if(res3.bad_email) {
                        this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant("alerts.upload_bad_emails"), duration: 4000 })
                      }
                      else {
                        this.translate.get('alerts.upload_ok').subscribe(res4 => {
                          this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                        })
                      }
                    }
                    else {
                      this.translate.get('alerts.upload_students_error').subscribe(res => {
                        this.showPrimarySpinner = false;
                        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
                      })
                    }
                  })
                })
              ).subscribe();
            }
          })
        })
      }
      reader.readAsBinaryString(file);
    }
    else {
      this.translate.get('alerts.file_required').subscribe(res4 => {
        this.showPrimarySpinner = false;
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
        return false;
      })
    }
  }

  selectFile(event, type) {
    if (type == 'primary') {
      this.selectedFiles = event.target.files;
    }
    // else {
    //   this.selectedSecondaryFiles = event.target.files;
    // }

  }

}
